// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__31FqM","productName":"Table_productName__nTc7p"};